/**
 * W3C traceparent generation for distributed tracing. One traceparent per logical request.
 * Backend (NestJS OpenTelemetry) reads traceparent and continues the trace.
 */

import { OBSERVABILITY_ENABLED } from './constants';

function randomHex(len: number): string {
  const bytes = new Uint8Array(len);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < len; i++) bytes[i] = Math.floor(Math.random() * 256);
  }
  return Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

/** Generate a new W3C traceparent header value: version-trace_id-parent_id-flags */
export function getTraceparentHeader(): string {
  if (!OBSERVABILITY_ENABLED) return '';
  const version = '00';
  const traceId = randomHex(16);
  const parentId = randomHex(8);
  const flags = '01';
  return `${version}-${traceId}-${parentId}-${flags}`;
}

/** Alias for interceptor usage. */
export function getTraceparent(): string {
  return getTraceparentHeader();
}
